import { productKnowledgeEntrySchema } from "@redotech/shopper-agent-knowledge-common/product-knowledge-view";
import { productKnowledgeIdFormat } from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";

export const getProductKnowledge = {
  name: "getProductKnowledge" as const,
  input: z.object({ id: productKnowledgeIdFormat.schema }),
  output: productKnowledgeEntrySchema,
};
